<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs10
      offset-xs1
      sm8
      offset-sm2
      md6
      offset-md3
      style="margin-top: 5%"
    >
      <h2 class="mb-3">
        Seleccione una fecha
      </h2>
      <div class="date-picker-wrapper">
        <v-date-picker
          v-model="selectedDate"
          :allowed-dates="allowedDates"
          locale="es"
          full-width
          :landscape="$vuetify.breakpoint.smAndUp"
          event-color="green lighten-1"
        />
      </div>
    </v-flex>
    <v-flex
      xs10
      my-5
      offset-xs1
      offset-sm2
      sm8
      md6
      offset-md3
    >
      <FreeAppointmentsTable
        :date="selectedDate"
        :loading="loading"
        :turnos-libres="turnosLibres"
        @accept="openDialog"
      />
    </v-flex>
    <AppointmentAcceptModal
      :message="verificationMessage"
      :appointment="selectedAppointment"
      :visible="dialogOpen"
      @accepted="appointmentAccepted"
    />
  </v-layout>
</template>

<script>
import { getTurnosLibres } from '../api/appointmentsEndpoints'
import FreeAppointmentsTable from '../components/appointments/FreeAppointmentsTable'
import AppointmentAcceptModal from '../components/appointments/AppointmentAcceptModal'
import moment from 'moment'

export default {
  name: 'CalendarView',
  components: { AppointmentAcceptModal, FreeAppointmentsTable },
  data () {
    return {
      turnos: [],
      turnosLibres: [],
      selectedDate: null,
      loading: false,
      dialogOpen: false,
      selectedAppointment: {},
      verificationMessage: ''
    }
  },
  watch: {
    async selectedDate (newValue) {
      if (newValue) {
        this.loading = true
        await this.getAppointmentList()
        this.loading = false
      }
    }
  },
  async mounted () {
    if (this.$route.params.turnos) {
      const params = this.$route.params.params
      const today = moment().format('YYYY-MM-DD')
      this.loading = true
      this.turnos = this.$route.params.turnos
      this.parseTurnos()
      this.selectedDate = today
      this.turnosLibres = await getTurnosLibres(params, today)
      this.loading = false
    } else {
      this.$router.push('/seleccion')
    }
  },
  methods: {
    allowedDates (val) {
      return this.turnos.indexOf(val) !== -1
    },
    parseTurnos () {
      this.turnos = this.turnos.map(t => `${t.fecha.substring(0, 4)}-${t.fecha.substring(4, 6)}-${t.fecha.substring(6, 8)}`)
    },
    async getAppointmentList () {
      const params = this.$route.params.params
      this.turnosLibres = await getTurnosLibres(params, this.selectedDate)
    },
    openDialog (props) {
      this.dialogOpen = true
      this.selectedAppointment = { ...props.appointment }
      this.verificationMessage = props.verification
    },
    async appointmentAccepted () {
      this.dialogOpen = false
      this.verificationMessage = ''
      await this.$store.dispatch('setSelectedAppointment', null)
      this.getAppointmentList()
    }
  }
}
</script>

<style lang="sass">
.date-picker-wrapper
  .v-btn__content
    font-size: 16px !important
    padding: 0
  .v-btn--active
    background-color: rgba(35, 128, 86, 0.78) !important
</style>
